// Readings: every assigned session across all classes, grouped by week.
//
// The catalog is static content in src/data/readings.js. Only the per-person "prepped"
// ticks are stored, in readingChecks/<personId>.done — a list of reading ids.

import { C, CLASSES } from "../data/classes.js";
import { addDays, d, fmt, fmtFull, iso, mondayOf, today } from "../lib/dates.js";
import { byId, el, esc } from "../lib/dom.js";
import { classChip } from "../lib/items.js";
import { S } from "../lib/state.js";
import { READINGS } from "../data/readings.js";

export function render(reads, rerender) {
  const filters = byId("readFilters");
  filters.innerHTML = "";
  CLASSES.forEach((c) => {
    const b = el("button", "chip", c.id);
    b.setAttribute("aria-pressed", S.readFilt[c.id] ? "true" : "false");
    b.onclick = () => {
      S.readFilt[c.id] ? delete S.readFilt[c.id] : (S.readFilt[c.id] = true);
      rerender();
    };
    filters.appendChild(b);
  });
  filters.appendChild(el("div", "div"));
  const hidePast = el("button", "chip", "Hide past weeks");
  hidePast.setAttribute("aria-pressed", S.readFilt.__past ? "true" : "false");
  hidePast.onclick = () => {
    S.readFilt.__past ? delete S.readFilt.__past : (S.readFilt.__past = true);
    rerender();
  };
  filters.appendChild(hidePast);

  const done = new Set((reads[S.me] && reads[S.me].done) || []);
  const thisMonday = mondayOf(today());
  const selected = Object.keys(S.readFilt).filter((k) => k !== "__past");
  const list = READINGS.filter((r) => !selected.length || selected.includes(r.cls));

  const weeks = {};
  list.forEach((r) => {
    const mk = iso(mondayOf(d(r.date)));
    (weeks[mk] = weeks[mk] || []).push(r);
  });

  const body = byId("readBody");
  body.innerHTML = "";
  const keys = Object.keys(weeks).sort();
  const shown = S.readFilt.__past ? keys.filter((k) => d(k) >= thisMonday) : keys;

  if (!shown.length) {
    body.appendChild(el("div", "empty", "No sessions match."));
    return;
  }

  shown.forEach((mk) => {
    const weekEnd = addDays(d(mk), 6);
    const isThisWeek = iso(thisMonday) === mk;
    const wrap = el("div", "readweek");
    const total = weeks[mk].length;
    const prepped = weeks[mk].filter((r) => done.has(r.id)).length;

    wrap.innerHTML =
      `<div class="week-head"${isThisWeek ? ' style="border-bottom-color:var(--brand)"' : ""}>
         <h3${isThisWeek ? ' style="color:var(--brand)"' : ""}>Week of ${fmt(mk)}${isThisWeek ? " · this week" : ""}</h3>
         <span class="range">${fmt(mk)} – ${fmt(iso(weekEnd))}</span>
         <span class="cnt">${prepped}/${total} prepped</span>
       </div>`;

    weeks[mk]
      .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : a.cls.localeCompare(b.cls)))
      .forEach((r) => {
        const c = C[r.cls];
        const isDone = done.has(r.id);
        const card = el("div", "sessioncard" + (isDone ? " done" : ""));
        if (c) card.style.borderLeftColor = `var(${c.v})`;
        card.innerHTML =
          `<div class="sh">
             ${classChip(r.cls)}
             <span class="date">${fmtFull(r.date)}</span>
             <span class="topic">${esc(r.topic)}</span>
             <span class="chk"><button class="chkbtn" data-read="${esc(r.id)}" aria-pressed="${isDone}">${isDone ? "✓ prepped" : "mark prepped"}</button></span>
           </div>` +
          `<ul class="rl">${r.items
            .map(([kind, citation]) => `<li class="${kind === "Case" ? "case" : ""}"><em>${esc(kind)}</em>${esc(citation)}</li>`)
            .join("")}</ul>` +
          (r.flag ? `<span class="flag">${esc(r.flag)}</span>` : "");
        wrap.appendChild(card);
      });

    body.appendChild(wrap);
  });
}
